/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type RXQuestionContentReplySuggestionType =
  (typeof RXQuestionContentReplySuggestionType)[keyof typeof RXQuestionContentReplySuggestionType];

export const RXQuestionContentReplySuggestionType = {
  multiple_choice_single: "multiple_choice_single",
  multiple_choice_multiple: "multiple_choice_multiple",
  single_select_dropdown: "single_select_dropdown",
  height_weight: "height_weight",
  free_text: "free_text",
  photo_upload: "photo_upload",
  "": "",
} as const;
